import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import Tooltip from '@atlaskit/tooltip';
import QuestionsIcon from '@atlaskit/icon/core/comment';
import { LinkMenuItem } from '@atlaskit/side-nav-items/link-menu-item';

import { useRouteName } from '@confluence/route-manager/entry-points/RouteState.ts';
import {
	SPACE_QUESTIONS,
	SPACE_QUESTIONS_NATIVE,
} from '@confluence/named-routes/entry-points/routes.ts';
import { usePageSpaceKey } from '@confluence/page-context';

type QuestionsLinkProps = {
	onClick: () => void;
	isLegacy?: boolean;
};

export const QuestionsLink = ({ onClick, isLegacy }: QuestionsLinkProps) => {
	const [spaceKey] = usePageSpaceKey();
	const isSelected = useRouteName(
		isLegacy ? isOnLegacySpaceQuestionsRoute : isOnSpaceQuestionsRoute,
	);
	const href = isLegacy
		? SPACE_QUESTIONS.toUrl({ spaceKey })
		: SPACE_QUESTIONS_NATIVE.toUrl({ spaceKey });

	return (
		<Tooltip position="top" content={<FormattedMessage {...i18n.questionsTooltip} />}>
			<LinkMenuItem
				href={href}
				onClick={onClick}
				elemBefore={<QuestionsIcon label="" color="currentColor" />}
				isSelected={isSelected}
			>
				<FormattedMessage {...i18n.questions} />
			</LinkMenuItem>
		</Tooltip>
	);
};

const isOnSpaceQuestionsRoute = {
	selector: (routeName: string | undefined) => routeName === SPACE_QUESTIONS_NATIVE.name,
};

const isOnLegacySpaceQuestionsRoute = {
	selector: (routeName: string | undefined) => routeName === SPACE_QUESTIONS.name,
};

const i18n = defineMessages({
	questions: {
		id: 'side-navigation.space-navigation.questions',
		defaultMessage: 'Questions',
		description: 'Label for the questions link in space navigation',
	},
	questionsTooltip: {
		id: 'side-navigation.space-navigation.questions.tooltip',
		defaultMessage: 'Ask and answer questions for this space',
		description: 'Tooltip on hover of the questions link in space navigation',
	},
});
